<template>
    <div class="centered-box-container">
        <div class="box-container">
            <div class="logo-container">
                <Logo class="logo" color="white"></Logo>
            </div>
            <div class="form-container">
                <h1>Truth Tree</h1>
                <transition name="slide">
                    <router-view></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import Logo from '../components/Logo';
    import Button from '../components/Button';

    export default {
        components: {
            Logo,
            Button
        }
    }
</script>

<style lang="scss">
    h1 {
        color: $primaryColor;
    }
    .slide-enter-active, .slide-leave-active {
        position: absolute;
        transition: all .5s;
        left: 0px;
        width: 100%;
    }
    .slide-enter {
        left: -500px;
    }
    .slide-leave-to {
        left: 500px;
    }

    .centered-box-container {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 100%;
        height: 100%;
    }

    .box-container {
        display: flex;
        justify-content: center;
        align-items: center;

        background-color: white;
        width: 640px;
        height: 480px;

        box-shadow: $shadow-big;
        box-sizing: border-box;
        border-radius: $rounded-corners;
        overflow: hidden;

        .logo-container {
            display: flex;
            align-items: center;

            background-color: $primaryColor;

            padding: $space-16;
            height: 100%;
            box-sizing: border-box;

            .logo {
                width: 120px;
                height: 120px;
            }
        }

        .form-container {
            position: relative;
            height: 100%;
            flex-grow: 1;
            background-color: white;
            overflow: hidden;
        }
    }
</style>